import React, { useState } from 'react'

import SearchBar from './SearchBar'
import SearchResults from './SearchResults'

const DealerFinder = ({ setDealer, noPadding = false }) => {
  const [searchData, setSearchData] = useState([])

  const updateSearchData = (data) => {
    setSearchData(data)
  }

  return (
    <div className={`dealer-finder ${noPadding ? '' : 'container'}`}>
      <SearchBar onSearchDataUpdate={updateSearchData} />
      <SearchResults searchData={searchData} setDealer={setDealer} />
    </div>
  )
}

export default DealerFinder
